import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';

import { TUserMeta, TUserMetaResponse, adaptUserMetaUndefinedFromResponse } from './user-meta.type';
import { adaptBrandSourceFromResponse, TBrandSource, TBrandSourceResponse } from './brand-source.type';
import { adaptProviderSourceFromResponse, TProviderSource, TProviderSourceResponse } from './provider-source.type';


export const ProviderBrandListSortCol = {
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TProviderBrandListSortCol = TTableSortCols<typeof ProviderBrandListSortCol>;

export type TProviderBrandListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TProviderBrandListSortCol;
};

export type TProviderBrandListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptProviderBrandListQueryToRequest(data?: TProviderBrandListQuery): TProviderBrandListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TProviderBrand = {
  id: number;
  name: string;
  description?: string;
	createdAt: string;
  updatedAt: string;

  provider: TProviderSource;
  brand: TBrandSource;
	createdBy?: TUserMeta;
	updatedBy?: TUserMeta;
};

export type TProviderBrandResponse = {
  id: number;
  name: string;
  description?: string;
  created_at: string;
  updated_at: string;

  provider: TProviderSourceResponse;
  brand: TBrandSourceResponse;
	created_by?: TUserMetaResponse;
	updated_by?: TUserMetaResponse;
};

export type TProviderBrandListResponse = TListResponse<TProviderBrandResponse>;

export type TProviderBrandList = TListResponse<TProviderBrand>;

export type TProviderBrandPayloadRequest = {
  brandId: number;
	providerId?: number;
  name?: string;
};

export type TProviderBrandRequest = {
  brand_id: number;
  provider_id?: number;
  name?: string;
};

export type TProviderBrandPayloadUpdate = {
	id: number;
	data: TProviderBrandPayloadRequest;
};

export function adaptProviderBrandFromListResponse(data: TProviderBrandListResponse): TProviderBrandList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptProviderBrandFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptProviderBrandFromResponse(data: TProviderBrandResponse): TProviderBrand {
	const {
		id,
		name,
		description,
		provider: providerRaw,
		brand: brandRaw,
		created_at: createdAt,
		updated_at: updatedAt,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
	} = data;

	const provider = adaptProviderSourceFromResponse(providerRaw);
	const brand = adaptBrandSourceFromResponse(brandRaw);
	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		name,
		description,
		provider,
		brand,
		createdAt,
		updatedAt,
		createdBy,
		updatedBy,
	};
}

export function adaptProviderBrandToRequest(data: TProviderBrandPayloadRequest): TProviderBrandRequest {
	const { brandId, providerId, name } = data;

	return {
		brand_id: brandId,
		provider_id: providerId,
		name,
	};
}
